import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCircle, faSignOutAlt, faGlobeAmericas,  faStar, faMailBulk} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserCircle, faSignOutAlt, faGlobeAmericas, faStar, faMailBulk)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false